import type { Event, EventEntity, VectorSearchResult } from '../types/api';
import { buildEventPath } from './slug';

/** Merge a search-index hit with its SQL detail rows into the shared event contract. */
export function vectorSearchResultToEvent(result: VectorSearchResult): Event {
  const details = Array.isArray(result.eventDetails) ? result.eventDetails : [];
  const primary = details[0];
  const seenEntityIds = new Set<number>();
  const entities: EventEntity[] = [];

  for (const detail of details) {
    if (!Number.isInteger(detail.entityId) || seenEntityIds.has(detail.entityId)) continue;
    seenEntityIds.add(detail.entityId);
    entities.push({
      id: detail.entityId,
      name: detail.entityName,
      displayName: detail.entityName,
      type: detail.typeName,
    });
  }

  const primaryEntity = entities[0];

  return {
    ...result,
    ...primary,
    eventId: result.databaseEventId,
    title: result.title,
    description: result.description || '',
    dateCreated: primary?.dateCreated ?? null,
    startDate: primary?.startDate || result.startDate || '',
    endDate: primary?.endDate || result.endDate || result.startDate || '',
    type: result.type ?? null,
    city: primary?.location?.city || result.city || undefined,
    state: primary?.location?.state || result.state || undefined,
    country: primary?.location?.country || result.country || undefined,
    venue: primary?.venue || result.venueDetails || result.venue || result.venueText || undefined,
    venueText: primary?.venueText ?? result.venueText ?? null,
    location: primary?.location || result.location || undefined,
    coordinates: primary?.coordinates || result.coordinates || undefined,
    isVirtual: primary?.isVirtual ?? result.isVirtual ?? false,
    isPartnerHosted: primary?.isPartnerHosted ?? result.isPartnerHosted ?? false,
    eventUrl: primary?.eventUrl || result.eventUrl || '',
    canonicalUrl: buildEventPath({ eventId: result.databaseEventId, title: result.title }),
    eventSources: [],
    entity: primaryEntity ? {
      id: primaryEntity.id,
      name: primaryEntity.name,
      type: primaryEntity.type,
    } : undefined,
    entities,
  };
}

export default vectorSearchResultToEvent;